import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {PreloaderComponent} from './components/common/preloader/preloader.component';
import {NavbarComponent} from './components/common/navbar/navbar.component';
import {FooterComponent} from './components/common/footer/footer.component';
import {HomeOneComponent} from './components/pages/home/home-one.component';
import {HomeTwoComponent} from './components/pages/_themePages/home-two/home-two.component';
import {HomeThreeComponent} from './components/pages/_themePages/home-three/home-three.component';
import {AboutComponent} from './components/pages/about/about.component';
import {JobListComponent} from './components/pages/job-list/job-list.component';
import {FavouriteJobComponent} from './components/pages/_themePages/favourite-job/favourite-job.component';
import {JobDetailsComponent} from './components/pages/job-details/job-details.component';
import {PostAJobComponent} from './components/pages/_themePages/post-a-job/post-a-job.component';
import {CandidateListComponent} from './components/pages/candidate-list/candidate-list.component';
import {ApplicationProfileComponent} from './components/pages/candidate-account/application-profile/application-profile.component';
import {SingleResumeComponent} from './components/pages/_themePages/single-resume/single-resume.component';
import {SubmitResumeComponent} from './components/pages/_themePages/submit-resume/submit-resume.component';
import {PricingComponent} from './components/pages/_themePages/pricing/pricing.component';
import {DashboardComponent} from './components/pages/_themePages/dashboard/dashboard.component';
import {CompanyListComponent} from './components/pages/_themePages/company-list/company-list.component';
import {CompanyDetailsComponent} from './components/pages/_themePages/company-details/company-details.component';
// import {LoginComponent} from './components/pages/login/login.component';
import {CreateAccountComponent} from './components/pages/_themePages/create-account/create-account.component';
import {ProfileComponent} from './components/pages/_themePages/profile/profile.component';
import {SingleProfileComponent} from './components/pages/_themePages/single-profile/single-profile.component';
import {NotFoundComponent} from './components/pages/not-found/not-found.component';
import {FaqComponent} from './components/pages/faq/faq.component';
import {PrivacyPolicyComponent} from './components/pages/privacy-policy/privacy-policy.component';
import {ContactComponent} from './components/pages/contact/contact.component';
import {BlogComponent} from './components/pages/blog/blog.component';
import {JobboardComponent} from './jobboard.component';
import {JobboardRoutingModule} from './jobboard-routing.module';
import {CounselingGuidanceComponent} from './components/pages/counseling-guidance/counseling-guidance.component';
import {ContentPageComponent} from './components/pages/content-page/content-page.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SimilarJobsComponent} from './components/pages/job-details/similar-jobs/similar-jobs.component';
import {AuthComponent} from './modules/auth/auth.component';
import {JobsComponent} from './modules/jobs/jobs.component';
import {JobsListComponent} from './modules/jobs/jobs-list/jobs-list.component';
import {RecommendCandidateComponent} from './components/pages/recommend-candidate/recommend-candidate.component';
import {LayoutModule} from '../crm/pages/layout.module';
import {SignupComponent} from './modules/auth/signup/signup.component';
import {CreateJobComponent} from './modules/jobs/create-job/create-job.component';
import {JobLoginComponent} from './modules/auth/login/login.component';
import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {HideTitleBarDirective} from './components/common/navbar/hide-title-bar.directive';
import {BreadcrumbService, NgBreadcrumbModule} from 'ng-breadcrumb';
import {HideBreadcrumbsDirective} from './components/common/navbar/hide-breadcrumbs.directive';
import {CandidateEditProfileComponent} from './components/pages/candidate-account/candidate-edit-profile/candidate-edit-profile.component';
import {CandidateProfileComponent} from './components/pages/candidate-account/candidate-profile/candidate-profile.component';
import {CheckCurrentUserComponent} from './components/common/check-current-user/check-current-user.component';
import {CompanyJobsListComponent} from './components/pages/company-account/company-jobs-list/company-jobs-list.component';
import {CompanyProfileComponent} from './components/pages/company-account/company-profile/company-profile.component';
import {CompanyEditProfileComponent} from './components/pages/company-account/company-edit-profile/company-edit-profile.component';
import {UserAccountComponent} from './modules/auth/user-account/user-account.component';
import {EditUserAccountComponent} from './modules/auth/user-account/edit-user-account/edit-user-account.component';
import {MainAccountDetailsComponent} from './modules/auth/user-account/main-account-details/main-account-details.component';
import {CompanyAddProfileComponent} from './components/pages/company-account/company-add-profile/company-add-profile.component';
import {SelectModule} from 'ng-select';
import {AngularEditorComponent, AngularEditorModule} from '@kolkov/angular-editor';
import {ViewMyApplicationsComponent} from './components/pages/candidate-account/view-my-applications/view-my-applications.component';
import {SingleApplicationComponent} from './components/pages/single-application/single-application.component';
import {ApplyJobComponent} from './components/pages/job-details/apply-job/apply-job.component';
import {UseLoaderDirective} from './shared/useLoader.directive';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {JobApplicationsComponent} from './components/pages/job-details/job-applications/job-applications.component';
import {NgSelect2Module} from 'ng-select2';
import {EditJobComponent} from './modules/jobs/edit-job/edit-job.component';
import {FormResponseComponent} from './shared/form-response/form-response.component';
import {ModalComponent} from './shared/modal/modal.component';
import {NgbPaginationModule, NgbRatingModule} from '@ng-bootstrap/ng-bootstrap';
import {FavoriteJobsComponent} from './components/pages/favorite-jobs/favorite-jobs.component';
import {ChangePasswordComponent} from './modules/auth/user-account/change-password/change-password.component';
import {ForgotPasswordComponent} from './modules/auth/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './modules/auth/reset-password/reset-password.component';
import {MyInterviewsComponent} from './components/pages/candidate-account/my-interviews/my-interviews.component';
import {CompaniesListComponent} from './components/pages/companies-list/companies-list.component';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {ShareIconsModule} from 'ngx-sharebuttons/icons';
import {SafePipe} from './shared/video-pipe/video-safe.pipe';
import {ResendActivationCodeComponent} from './modules/auth/resend-activation-code/resend-activation-code.component';
import {SharedModuleModule} from '../shared-module/shared-module.module';
import {EnumTransformPipe} from '../shared-module/enumTransform/enum-transform.pipe';
import {TranslateModule} from '@ngx-translate/core';
import {CompanyCreditsComponent} from './components/pages/company-account/company-credits/company-credits.component';
import {TermsAndConditionsComponent} from './components/pages/terms-and-conditions/terms-and-conditions.component';
import {SalaryComparatorComponent} from './components/pages/salary-comparator/salary-comparator.component';
import {ServicesAgriJobsComponent} from './components/pages/services-agri-jobs/services-agri-jobs.component';
import {PackagesComponent} from './components/pages/packages/packages.component';
import {EmployerBrandComponent} from './components/pages/employer-brand/employer-brand.component';
import {MyCareerComponent} from './components/pages/my-career/my-career.component';
import {AgriBusinessComponent} from './components/pages/agri-business/agri-business.component';
import {AgriJobComponent} from './components/pages/agri-job/agri-job.component';
import {AgriStaffComponent} from './components/pages/agri-staff/agri-staff.component';
import {AgencyRecruiterComponent} from './components/pages/agency-recruiter/agency-recruiter.component';
import {BlogDetailsComponent} from './components/pages/blog-details/blog-details.component';
import {SalaryPackagesComponent} from './components/pages/salary-packages/salary-packages.component';
import {SalaryStudyComponent} from './components/pages/salary-study/salary-study.component';
import { PersonalityAndBehavioralProfileComponent } from './components/pages/personality-and-behavioral-profile/personality-and-behavioral-profile.component';

@NgModule({
    declarations: [
        JobboardComponent,
        PreloaderComponent,
        FooterComponent,
        NavbarComponent,
        HomeOneComponent,
        HomeTwoComponent,
        HomeThreeComponent,
        SalaryStudyComponent,
        AboutComponent,
        JobListComponent,
        SalaryPackagesComponent,
        PackagesComponent,
        EmployerBrandComponent,
        MyCareerComponent,
        ServicesAgriJobsComponent,
        FavouriteJobComponent,
        JobDetailsComponent,
        PostAJobComponent,
        CandidateListComponent,
        ApplicationProfileComponent,
        SingleResumeComponent,
        SubmitResumeComponent,
        PricingComponent,
        DashboardComponent,
        CompanyListComponent,
        CompanyDetailsComponent,
        // LoginComponent,
        CreateAccountComponent,
        ProfileComponent,
        SingleProfileComponent,
        NotFoundComponent,
        FaqComponent,
        TermsAndConditionsComponent,
        PrivacyPolicyComponent,
        ContactComponent,
        BlogComponent,
        BlogDetailsComponent,
        CounselingGuidanceComponent,
        ContentPageComponent,
        SimilarJobsComponent,
        AuthComponent,
        JobsComponent,
        SignupComponent,
        CreateJobComponent,
        JobLoginComponent,
        CandidateEditProfileComponent,
        CandidateProfileComponent,
        CheckCurrentUserComponent,
        JobsListComponent,
        SalaryComparatorComponent,
        RecommendCandidateComponent,
        SignupComponent,
        CreateJobComponent,
        JobLoginComponent,
        HideTitleBarDirective,
        HideBreadcrumbsDirective,
        CandidateEditProfileComponent,
        CandidateProfileComponent,
        CheckCurrentUserComponent,
        CompanyJobsListComponent,
        CompanyProfileComponent,
        CompanyEditProfileComponent,
        UserAccountComponent,
        MainAccountDetailsComponent,
        EditUserAccountComponent,
        CompanyAddProfileComponent,
        ViewMyApplicationsComponent,
        SingleApplicationComponent,
        ApplyJobComponent,
        UseLoaderDirective,
        JobApplicationsComponent,
        FormResponseComponent,
        ApplyJobComponent,
        ModalComponent,
        EditJobComponent,
        FormResponseComponent,
        FavoriteJobsComponent,
        ChangePasswordComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        MyInterviewsComponent,
        CompaniesListComponent,
        AgencyRecruiterComponent,
        SafePipe,
        ResendActivationCodeComponent,
        CompanyCreditsComponent,
        AgriBusinessComponent,
        AgriJobComponent,
        AgriStaffComponent,
        PersonalityAndBehavioralProfileComponent
    ],
    imports: [
        BrowserModule,
        JobboardRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgBreadcrumbModule,
        SelectModule,
        AngularEditorModule,
        NgSelect2Module,
        NgxMaterialTimepickerModule,
        ReactiveFormsModule,
        NgbRatingModule,
        NgbPaginationModule,
        ShareButtonsModule,
        ShareIconsModule,
        SharedModuleModule,
        TranslateModule
    ],
    providers: [],
    bootstrap: [JobboardComponent]
})
export class JobboardModule {

}
